import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { WorkshopProvider } from "./context";

const SupportCoursesDashboard = lazy(() => import("./dashboard"));
const SupportCoursesDetails = lazy(() => import("./details"));
const CreateSupportCoursesPage = lazy(() => import("./create"));
const ErrorPage = lazy(() => import("@root/error"));

export const supportCourseRoutes: RouteObject[] = [
  {
    path: "/support-courses/dashboard",
    element: (
      <WorkshopProvider>
        <SupportCoursesDashboard />
      </WorkshopProvider>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/support-courses/:id",
    element: (
      <WorkshopProvider>
        <SupportCoursesDetails />
      </WorkshopProvider>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/support-courses",
    element: (
      <WorkshopProvider>
        <CreateSupportCoursesPage />
      </WorkshopProvider>
    ),
    errorElement: <ErrorPage />,
  },
];
